import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { appVersion } from 'src/environments/version';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})

export class FooterComponent implements OnInit{

  public appVersion = appVersion;
  lacpointSiteUrl: string = environment.wordpressUrl;
  currentYear: number; // Armazena o ano atual

  constructor(){}

  ngOnInit(): void {
    const currentDate = new Date(); // busca a data atual
    this.currentYear = currentDate.getFullYear(); // busca o ano atual, por exemplo: 2024
  }
}
